import { lazy } from "react";
import Loadable from "components/Loadable";

const NoDueCertificateTabs = Loadable(
  lazy(() => import("features/noDueCertificate/components/NoDueCertificateTabs"))
);

const routes = {
  path: "member",
  children: [{ path: "noDueCertificate", element: <NoDueCertificateTabs /> }],
};

export default routes;
